export const TAB_STYLES = {
  base: 'rounded-none pb-[9px] !uppercase text-core-gray-700 hover:!text-black border-b-transparent border-b-[3px] focus:outline-none focus:ring-0 focus:ring-transparent focus:right-offset-0',
  get multi() {
    return this.base + ' data-[selected]:border-homestead-yellow data-[selected]:!text-black'
  },
  active: '!border-b-homestead-yellow !border-b-[3px] !text-black',
  disabled: '!opacity-80 cursor-not-allowed hover:!text-homestead-blue',
} as const

export const SCROLL_BEHAVIOR_CONFIG = {
  behavior: 'smooth' as const,
  block: 'start' as const,
}
